<template>
  <div class="privacyAgreementManage-container">
    <div class="container-title"><span class="centered-text">JLL法律声明及隐私权政策</span></div>
    <div class="agreement-describe"><span>更新时间:{{agreementModifyTimeStr}} &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; 最新版本号:{{agreementCurrentVersion}}</span></div>
    <quill-editor  style="height:400px;" ref="text" v-model="agreementContent" class="editor" :options="editorOption"/>
     <div class="handle-button">
          <el-button  @click="handlePublic">发布</el-button>
          <el-button @click="handleTempSave">暂存</el-button>
          <el-button @click="handleBack">恢复</el-button>
      </div>
    <el-dialog title="是否发布新版本隐私协议" v-model="publicDialogVisible" @close="cancelPublicDialog">
      <el-form :model="publicAgreementForm" :rules="publicAgreementFormRules" ref="publicAgreementForm">
          <span style="margin-left: 52px;">发布新版本隐私协议后，全部用户登录系统时需要再次同意 </span>
          <el-form-item label="当前版本号为：" prop="version" style="margin-top: 22px;width: 500px;" label-width="150px">
              <el-input placeholder="请输入版本号" v-model="publicAgreementForm.version" auto-complete="off" ></el-input>
          </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
            <el-button v-bind:disabled="publicAgreementButtonDisabled" type="primary" @click="publicAgreementOnSubmit">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="回退确认" v-model="backAgreementDialogVisible" @close="cancelBackAgreementDialog">
        <span >是否要回退到上次发布版本 </span>
        <div slot="footer" class="dialog-footer">
        <el-button @click="cancelBackAgreementDialog">取 消</el-button>
        <el-button v-bind:disabled="backAgreementButtonDisabled" type="primary" @click="backAgreementOnSubmit">确 定</el-button>
      </div>
    </el-dialog>

  </div>
  
</template>

<script>
  import api from '@/api';
  import tools from '@/util/tools';
  import Vue from 'vue';
  export default {
    data() {
      return {
        listLoading: false,
        logining: false,
        publicDialogVisible:false,
        backAgreementDialogVisible:false,
        agreementContent:"",
        agreementCurrentVersion:"",
        agreementModifyTimeStr:"",
        backAgreementButtonDisabled:false,
        publicAgreementButtonDisabled:false,
        editorOption: {},
        publicAgreementForm: {
            version:''
        },
        publicAgreementFormRules: {
					version: [
						{ required: true, message: '版本号不能为空', trigger: 'blur' },
            { pattern: /^v\d+\.\d+\.\d+$/ ,message: '版本号不合法',trigger: 'blur'},
					]
        },
      };
    },
    methods: {
      handlePublic(){
        this.publicDialogVisible = true;
      },
      cancelPublicDialog(){
        this.publicDialogVisible = false;
      },
      publicAgreementOnSubmit(){
        this.agreementContent = this.$refs.text.value;
        if(!tools.trim(this.publicAgreementForm.version)){
            tools.error(this,'协议版本号不能为空');
            return;
        }
        if(!tools.trim(this.agreementContent)){
            tools.error(this,'协议内容不能为空');
            return;
        }
        let self = this;
        this.$refs.publicAgreementForm.validate((valid) => {
            if (valid) {
              this.publicAgreementButtonDisabled = true;
				      let param = {version:this.publicAgreementForm.version,content:this.agreementContent};
              api.acquireData_publishAgreement_request(param).then((res) => {
                this.publicAgreementButtonDisabled = false;
                this.publicDialogVisible = false;
                this.$refs.publicAgreementForm.resetFields();
                tools.success(this,'发布协议成功');
                this.getTempAgreement();
                this.getNewestPrivacyAgreement();
              }).catch(function (e) {
                self.publicAgreementButtonDisabled = false;
                console.log(e);
                tools.error(new Vue(),e.message);
              });
            }
        })
			},
      handleBack(){
        this.backAgreementDialogVisible = true;
      },
      cancelBackAgreementDialog(){
        this.backAgreementDialogVisible = false;
      },
      backAgreementOnSubmit(){
        this.backAgreementDialogVisible = false;
				this.getNewestPrivacyAgreement();
        let param = {};
				api.acquireData_searchNewestAgreement_request(param).then((res) => {
					if(res.data){
            this.agreementContent = res.data.content;
            tools.success(this,'回退成功');
					}
				}).catch(function (e) {
					console.log(e);
          tools.error(new Vue(),e.message);
				});
        
			},
      handleTempSave(){
        console.log("富文本内容=",this.$refs.text.value);
        this.agreementContent = this.$refs.text.value;
        if(!tools.trim(this.agreementContent)){
            tools.error(this,'协议内容不能为空');
            return;
        }
				let param = {content:this.agreementContent};
				api.acquireData_saveTempAgreement_request(param).then((res) => {
					tools.success(this,'暂存成功');
				}).catch(function (e) {
					console.log(e);
          tools.error(this,'暂存失败');
				});
			},
      getNewestPrivacyAgreement(){
				let param = {};
				api.acquireData_searchNewestAgreement_request(param).then((res) => {
					if(res.data){
            this.agreementCurrentVersion = res.data.currentVersion;
            this.agreementModifyTimeStr = res.data.modifyTimeStr;
            this.agreementContent = res.data.content;
					}
				}).catch(function (e) {
					console.log(e);
          tools.error(new Vue(),e.message);
				});
			},
      getTempAgreement(){
				let param = {};
        let self = this;
				api.acquireData_searchTempAgreement_request(param).then((res) => {
					if(res.data){
            this.agreementContent = res.data.content;
					}
				}).catch(function (e) {
					console.log(e);
          tools.error(new Vue(),e.message);
				});
			},
    },
    mounted() {
			this.getTempAgreement();
      this.getNewestPrivacyAgreement();
		}
  }

</script>

<style lang="scss" scoped>
  .privacyAgreementManage-container {
    margin-top:20px;
    //border:1px solid #f3f3f3;
    .container-title {
      font-size: 18px;
      height:30px;
      padding-left:10px;
      padding-top:20px;
      padding-bottom:30px;
      background:#f3f3f3;
    }
  }
  .centered-text {
    display: flex;
    align-items: center;
    justify-content: center; /* 如果你还希望文字水平居中 */
    height: 50px; /* 设置一个高度，使得垂直居中有参考 */
  }
  .handle-button {
     margin-top:50px;
     margin-left:40%;
  }
  .agreement-describe{
    background:#f3f3f3;
    padding-right:10%;
    padding-bottom: 10px;
    color: #9195a3;
    text-align: right;
  }
</style>


// WEBPACK FOOTER //
// privacy_agreement_manage.vue?ab2bb3fa